<template>
    <div>
        <div class="alert alert-primary text-center mt-3">
            <div class="lead mr-2">Recibo</div>
            <div class="display-4" v-if="dados">
                Nº {{ dados.id_pagamento_atendimento }}
            </div>
            <div v-else>Carregando...</div>
        </div>

        <div class="progress mt-1 mb-3">
            <div
                class="indeterminate"
                v-if="$store.state.loading && dados"
            ></div>
            <div class="determinate" v-else></div>
        </div>

        <!-- Notas Fiscais -->
        <template v-if="dados && dados.unidade_operacao && dados.unidade_operacao.fl_nota_fiscal">
            <button class="btn btn-outline-primary mb-2" @click.prevent="gerarNF()" :disabled="$store.state.loading" v-if="!view">
                {{ (listaNf && listaNf.length == 0 ) ? 'Emitir Nota Fiscal' : 'Regerar Nota Fiscal' }}
            </button>

            <template v-if="dados.zoop">
                <zoop-pagamento :pagamento="dados" />

                <!-- Documentos para Impressão -->
                <doc-print-atendimento class="mt-3" :marcacao="dados" :id_pagamento_atendimento="dados.id_pagamento_atendimento" />
            </template>

            <!-- <zoop-status v-if="false && can_open_zoop" :id_pagamento_atendimento="dados.id_pagamento_atendimento" /> -->
            <suport-pos-status v-if="can_open_suportepos" class="mb-3" ref="suportposStatus" @refresh="load()" :id_pagamento_atendimento="dados.id_pagamento_atendimento" :id_unidade_operacao="dados.id_unidade_operacao" />
            
            <template v-if="possuiNF">
                <az-sub-title title="Notas fiscais" />

                <div class="list-group mb-3">
                    <div class="list-group-item d-flex" v-for="(nfl, idx) in listaNf" :key="idx">
                        <span class="mr-3">{{ $util.getFormatDate(nfl.nota_fiscal_servico.dt_emissao) }}</span>
                        <span class="mr-3">{{ nfl.nota_fiscal_servico.numero_completo }}</span>
                        <span class="mr-3">{{ nfl.nota_fiscal_servico.st_tomador_nome }}</span>
                        <span class="mr-3" v-if="nfl.nota_fiscal_servico.unidade_operacao">
                            <span class="badge badge-dark" title="Unidade Emissora da Nota Fiscal">
                            {{ nfl.nota_fiscal_servico.unidade_operacao.st_sigla 
                                ? nfl.nota_fiscal_servico.unidade_operacao.st_sigla 
                                : nfl.nota_fiscal_servico.unidade_operacao.st_nome }}
                            </span>
                        </span>
                        <span class="mr-3" :class="getStatusClass(nfl.nota_fiscal_servico.ch_status)">
                            {{ nfl.nota_fiscal_servico.descricao_status }}
                        </span>
                        <span class="mr-3" v-if="dados && dados.unidade_operacao && dados.unidade_operacao.fl_nota_fiscal_eletronica">
                            <nota-fiscal-status
                                :exibirEditar="false"
                                :notaFiscal="nfl.nota_fiscal_servico"
                                @refresh="abrir(null)" />
                        </span>
                    </div>
                </div>
            </template>
        </template>

        <div v-if="dados" v-show="false">
            <html-report id="recibo" :header="false" :forceheader="false" ref="reportRecibo">
                <!-- Copia 1 -->
                <div style="font-size:16px;">
                    <div v-if="unidade && ( !unidade.fl_timbrado || true )" style="line-height: 95%;">
                        <div class="d-flex justify-content-between">
                            <div class="d-flex flex-column">
                                <h4 v-if="parms && parms.nome_contratado" class="mb-0">
                                    {{ parms.nome_contratado }}
                                </h4>
                                <h4 v-else class="mb-0">
                                    {{ unidade.st_nome_fantasia }}
                                </h4>
                                <h6 v-if="unidade.st_unidade_operacao && unidade.unidade_operacaos && unidade.unidade_operacaos.length > 1" class="mb-0">
                                    {{ unidade.st_unidade_operacao }}
                                </h6>
                                <p
                                    v-if="unidade.endereco"
                                    class="font-weight-light"
                                >
                                    {{ unidade.endereco.st_logradouro }},
                                    {{ unidade.endereco.st_numero }}
                                    <span v-if="unidade.endereco.st_complemento">- {{ unidade.endereco.st_complemento }}</span>
                                    - Bairro: {{ unidade.endereco.st_bairro }}
                                    - Cep:
                                    {{
                                        this.$util.formatMask(
                                            unidade.endereco.in_cep,
                                            "cep"
                                        )
                                    }}-
                                    {{
                                        unidade.endereco.cidade
                                            ? unidade.endereco.cidade.st_cidade
                                            : ""
                                    }}
                                </p>
                                <div>
                                    <div
                                        v-if="parms && parms.codigo_contratado"
                                    >
                                        {{ parms.codigo_contratado }}
                                    </div>
                                    <div v-else-if="unidade.st_cnpj">
                                        CNPJ:
                                        {{
                                            this.$util.formatMask(
                                                unidade.st_cnpj,
                                                "cnpj"
                                            )
                                        }}
                                    </div>
                                    <div
                                        v-if="unidade.st_telefone_representante"
                                    >
                                        Tel:
                                        {{
                                            this.$util.formatMask(
                                                unidade.st_telefone_representante,
                                                unidade
                                                    .st_telefone_representante
                                                    .length == 10
                                                    ? "tel"
                                                    : "cel"
                                            )
                                        }}
                                    </div>
                                    <br />
                                </div>
                            </div>
                            <div v-if="logo_url">
                                <img v-if="logo_url" :src="logo_url" height="120mm" />
                                <img v-else-if="$store.state.logo" :src="$store.state.logo" height="120mm" />
                            </div>
                        </div>
                    </div>

                    <div class="d-flex flex-column" stylex="margin-top:1cm;">
                        <h3 class="mx-auto mb-3">
                            Recibo Nª {{ dados.id_pagamento_atendimento }}
                        </h3>
                        <div style="text-align: justify; text-justify: inter-word;" class="mb-3">
                            Recebemos de {{ responsavel }} a importância de R$
                            {{ this.$util.formatMoeda(valor_total) }} 
                            <span v-if="dados.dc_valor_adiantado">
                                referente a adiantamento.
                            </span>
                            <span v-else>
                                referente a quitação de despesas médicas conforme dados
                                {{ dados.lista_atendimentos.length > 1 ? 'dos atendimentos' : 'do atendimento' }}
                                Nº {{ dados.lista_atendimentos.join(', ') }}.
                            </span>
                        </div>

                        <div v-if="dados && dados.st_observacoes">
                            <div class="mb-3">{{ dados.st_observacoes }}</div>
                        </div>

                        <div v-if="metodoPagamentos" class="mb-3">
                            <ul v-for="(pagamento, index) in metodoPagamentos" :key="index" style="line-height: 70%;">
                                <li>
                                    <small v-if="pagamento.forma_pagamento">
                                        {{ pagamento.forma_pagamento }}
                                    </small>
                                    {{ pagamento.st_pagamento }}: R$
                                    {{ $util.formatMoeda(pagamento.dc_valor) }}

                                    <span v-if="pagamento.transaction_id" class="ml-5 small text-muted">
                                        {{ pagamento.transaction_id }}
                                    </span>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div class="d-flex flex-column">
                        <template v-if="false">
                            <div
                                class="font-weight-bold border-bottom w-100 d-flex justify-content-center"
                            >
                                <h4>Dados do Atendimento</h4>
                            </div>
                            <div class="d-flex flex-column p-3">
                                <div class="row d-flex">
                                    <p class="mr-2">
                                        Registro: {{ dados.id_pagamento_atendimento }}
                                    </p>
                                    <p v-if="dados.paciente && dados.paciente.st_nome_social" class="mr-2">
                                        Paciente: {{ dados.paciente.st_nome_social }}
                                    </p>
                                    <p v-else-if="dados.paciente" class="mr-2">
                                        Paciente:{{ dados.paciente.st_nome }}
                                    </p>
                                </div>
                                <p class="row" v-if="endereco">
                                    {{ endereco }}
                                </p>

                                <!-- Endereço:{{ dados.paciente.cadastro.endereco.st_logradouro }},{{ dados.paciente.cadastro.endereco.st_numero}} Bairro: {{ dados.paciente.cadastro.endereco.st_bairro }}. {{dados.paciente.cadastro.endereco.cidade ? dados.paciente.cadastro.endereco.cidade.st_cidade : ''}}</p> -->
                                <div class="d-flex row">
                                    <p class="mr-2">
                                        Nª do Atendimento: {{ dados.lista_atendimentos.join(', ') }}
                                    </p>
                                    <p class="mr-2">
                                        Data Atendimento:
                                        <span v-for="(data, idx) in this.dados.procedimentos.data.map(item => item.data)" :key="idx">
                                            {{ formatData(data) }}
                                        </span>
                                    </p>
                                </div>
                            </div>
                        </template>

                        <template v-if="dados.procedimentos && dados.procedimentos.length">
                            <div class="d-flex flex-column">
                                <div class="font-weight-bold border-bottom w-100 mx-auto">
                                    Serviços Realizados
                                </div>
                                <table class="border-bottom">
                                    <thead class="font-weight-bold">
                                        <tr>
                                            <td class="w-50">
                                                Procedimento(s)
                                            </td>
                                            <td></td>
                                            <td class="text-right">
                                                Quantidade
                                            </td>
                                            <td class="text-right" v-if="!block_valor_unit">
                                                Valor(R$)
                                            </td>
                                        </tr>
                                    </thead>
                                    <tbody class="border border-left-0 border-right-0">
                                        <template v-for="(item, id) in procedimentos">
                                            <tr :key="id" class="border-top" v-if="true">
                                                <td>{{ item.nome }}</td>
                                                <td></td>
                                                <td class="text-right">
                                                    {{ item.quantidade }}
                                                </td>
                                                <td class="text-right" v-if="!block_valor_unit">
                                                    {{
                                                        formatCurrency(
                                                            item.valor
                                                        )
                                                    }}
                                                </td>
                                            </tr>

                                            <tr v-if="item.consumos.length" class="my-1 font-weight-bold mr-2" style="font-size:12px; margin-left:2cm; width:91%;" :key="'mat' + id">
                                                <td class="pl-4">
                                                    Material/Medicamento
                                                </td>
                                                <td class="text-right" v-if="!block_valor_unit">
                                                    Valor Unitário
                                                </td>
                                                <td class="text-right">
                                                    Quantidade
                                                </td>
                                                <td class="text-right" v-if="!block_valor_unit">
                                                    Valor Total(R$)
                                                </td>
                                            </tr>

                                            <tr v-for="(itemConsumo, indice) in item.consumos" :key="'consumo' + id + '.' + indice" class="mr-2">
                                                <td class="pl-4">
                                                    {{ itemConsumo.nome_item }}
                                                </td>
                                                <td class="text-right" v-if="!block_valor_unit">
                                                    {{
                                                        formatCurrency(
                                                            itemConsumo.valor_unitario
                                                        )
                                                    }}
                                                </td>
                                                <td class="text-right">
                                                    {{ itemConsumo.quantidade }}
                                                </td>
                                                <td class="text-right" v-if="!block_valor_unit">
                                                    {{
                                                        formatCurrency(
                                                            itemConsumo.valor
                                                        )
                                                    }}
                                                </td>
                                            </tr>
                                        </template>
                                    </tbody>
                                </table>
                            </div>

                            <div class="d-flex justify-content-between mt-4">
                                <div>
                                    <div v-if="dados.medico_no_recibo && dados.atendimento && dados.atendimento.medico" class="small">
                                        {{ dados.atendimento.medico.st_nome_exibicao }}
                                        <div v-if="dados.atendimento.medico.conselho">
                                            {{ dados.atendimento.medico.conselho.st_sigla }}
                                            {{ dados.atendimento.medico.in_numero_conselho }}
                                            <span v-if="dados.atendimento.medico.estado_conselho">
                                                {{ dados.atendimento.medico.estado_conselho.st_sigla }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <table class="text-right">
                                    <tr class="ml-2">
                                        <td class="font-weight-bold">
                                            Valor Total(R$):
                                        </td>
                                        <td>{{ formatCurrency(total) }}</td>
                                    </tr>
                                    <tr class="ml-2">
                                        <td class="font-weight-bold">
                                            Valor Desconto(R$):
                                        </td>
                                        <td>{{ formatCurrency(desconto) }}</td>
                                    </tr>
                                    <tr class="ml-2">
                                        <td class="font-weight-bold">
                                            Valor Pago(R$):
                                        </td>
                                        <td>
                                            {{
                                                formatCurrency(total - desconto)
                                            }}
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </template>
                    </div>

                    <div v-if="dados" class="mx-auto" style="font-size:14px;">
                        {{
                            dados.unidade_operacao && 
                            dados.unidade_operacao.endereco &&
                            dados.unidade_operacao.endereco.cidade
                                ? dados.unidade_operacao.endereco.cidade.st_cidade + ', '
                                : ""
                        }}
                        <span v-if="dados.dt_data">
                            {{ formatData(dados.dt_data.substr(0,10)) }}
                        </span>
                    </div>

                    <div class="d-flex justify-content-between mt-2 ml-4 mr-4">
                        <div
                            class="d-flex flex-column justify-content-center ml-5 text-center"
                        >
                            <div>
                                __________________________________________
                            </div>
                            <div><small>Paciente</small></div>
                        </div>
                        <div
                            class="d-flex flex-column justify-content-center ml-5 text-center"
                        >
                            <div>
                                __________________________________________
                            </div>
                            <div><small>Clínica</small></div>
                        </div>
                    </div>
                </div>

                <div class="alert alert-secondary py-1 mt-3" 
                    style="white-space: pre; font-size:10px;"
                    v-if="dados.texto_recibo_adiantamento">{{ dados.texto_recibo_adiantamento }}</div>

                <div class="d-flex justify-content-center mt-4 mb-4">
                    <span>----------------------------------------------------------------</span>
                </div>

                <!-- Copia 2 -->
                <div style="font-size:16px;">
                    <div
                        v-if="unidade && ( !unidade.fl_timbrado || true )"
                        style="line-height: 95%;"
                    >
                        <div class="d-flex justify-content-between">
                            <div class="d-flex flex-column">
                                <h4 v-if="parms && parms.nome_contratado" class="mb-0">
                                    {{ parms.nome_contratado }}
                                </h4>
                                <h4 v-else class="mb-0">
                                    {{ unidade.st_nome_fantasia }}
                                </h4>
                                <h6 v-if="unidade.st_unidade_operacao" class="mb-0">
                                    {{ unidade.st_unidade_operacao }}
                                </h6>
                                <p
                                    v-if="unidade.endereco"
                                    class="font-weight-light"
                                >
                                    {{ unidade.endereco.st_logradouro }} ,
                                    {{ unidade.endereco.st_numero }}
                                    <span v-if="unidade.endereco.st_complemento">- {{ unidade.endereco.st_complemento }}</span>
                                    - Bairro: {{ unidade.endereco.st_bairro }}
                                    - Cep:
                                    {{
                                        this.$util.formatMask(
                                            unidade.endereco.in_cep,
                                            "cep"
                                        )
                                    }}-
                                    {{
                                        unidade.endereco.cidade
                                            ? unidade.endereco.cidade.st_cidade
                                            : ""
                                    }}
                                </p>
                                <div>
                                    <div
                                        v-if="parms && parms.codigo_contratado"
                                    >
                                        {{ parms.codigo_contratado }}
                                    </div>
                                    <div v-else-if="unidade.st_cnpj">
                                        CNPJ:
                                        {{
                                            this.$util.formatMask(
                                                unidade.st_cnpj,
                                                "cnpj"
                                            )
                                        }}
                                    </div>
                                    <div
                                        v-if="unidade.st_telefone_representante"
                                    >
                                        Tel:
                                        {{
                                            this.$util.formatMask(
                                                unidade.st_telefone_representante,
                                                unidade
                                                    .st_telefone_representante
                                                    .length == 10
                                                    ? "tel"
                                                    : "cel"
                                            )
                                        }}
                                    </div>
                                    <br />
                                </div>
                            </div>
                            <div v-if="logo_url">
                                <img v-if="logo_url" :src="logo_url" height="120mm" />
                                <img v-else-if="$store.state.logo" :src="$store.state.logo" height="120mm" />
                            </div>
                        </div>
                    </div>

                    <div class="d-flex flex-column" stylex="margin-top:1cm;">
                        <h3 class="mx-auto mb-3">
                            Recibo Nª {{ dados.id_pagamento_atendimento }}
                        </h3>
                        <div style="text-align: justify; text-justify: inter-word;" class="mb-3">
                            Recebemos de {{ responsavel }} a importância de R$
                            {{ this.$util.formatMoeda(valor_total) }} 
                            <span v-if="dados.dc_valor_adiantado">
                                referente a adiantamento.
                            </span>
                            <span v-else>
                                referente a quitação de despesas médicas conforme dados
                                {{ dados.lista_atendimentos.length > 1 ? 'dos atendimentos' : 'do atendimento' }}
                                Nº {{ dados.lista_atendimentos.join(', ') }}.
                            </span>
                        </div>

                        <div v-if="dados && dados.st_observacoes">
                            <div class="mb-3">{{ dados.st_observacoes }}</div>
                        </div>

                        <div v-if="metodoPagamentos" class="mb-3">
                            <ul v-for="(pagamento, index) in metodoPagamentos" :key="index" style="line-height: 70%;">
                                <li>
                                    <small v-if="pagamento.forma_pagamento">
                                        {{ pagamento.forma_pagamento }}
                                    </small>
                                    {{ pagamento.st_pagamento }}: R$
                                    {{ $util.formatMoeda(pagamento.dc_valor) }}

                                    <span v-if="pagamento.transaction_id" class="ml-5 small text-muted">
                                        {{ pagamento.transaction_id }}
                                    </span>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div class="d-flex flex-column">
                        <template v-if="dados.procedimentos && dados.procedimentos.length">
                            <div class="d-flex flex-column">
                                <div class="font-weight-bold border-bottom w-100 mx-auto">
                                    Serviços Realizados
                                </div>
                                <table class="border-bottom">
                                    <thead class="font-weight-bold">
                                        <tr>
                                            <td class="w-50">
                                                Procedimento(s)
                                            </td>
                                            <td></td>
                                            <td class="text-right">
                                                Quantidade
                                            </td>
                                            <td class="text-right" v-if="!block_valor_unit">
                                                Valor(R$)
                                            </td>
                                        </tr>
                                    </thead>
                                    <tbody class="border border-left-0 border-right-0">
                                        <template v-for="(item, id) in procedimentos">
                                            <tr :key="id" class="border-top" v-if="true">
                                                <td>{{ item.nome }}</td>
                                                <td></td>
                                                <td class="text-right">
                                                    {{ item.quantidade }}
                                                </td>
                                                <td class="text-right" v-if="!block_valor_unit">
                                                    {{
                                                        formatCurrency(
                                                            item.valor
                                                        )
                                                    }}
                                                </td>
                                            </tr>

                                            <tr v-if="item.consumos.length" class="my-1 font-weight-bold mr-2" style="font-size:12px; margin-left:2cm; width:91%;" :key="'mat' + id">
                                                <td class="pl-4">
                                                    Material/Medicamento
                                                </td>
                                                <td class="text-right" v-if="!block_valor_unit">
                                                    Valor Unitário
                                                </td>
                                                <td class="text-right">
                                                    Quantidade
                                                </td>
                                                <td class="text-right" v-if="!block_valor_unit">
                                                    Valor Total(R$)
                                                </td>
                                            </tr>

                                            <tr v-for="(itemConsumo, indice) in item.consumos" :key="'consumo-' + id + '.' + indice" class="mr-2">
                                                <td class="pl-4">
                                                    {{ itemConsumo.nome_item }}
                                                </td>
                                                <td class="text-right" v-if="!block_valor_unit">
                                                    {{ formatCurrency(itemConsumo.valor_unitario) }}
                                                </td>
                                                <td class="text-right">
                                                    {{ itemConsumo.quantidade }}
                                                </td>
                                                <td class="text-right" v-if="!block_valor_unit">
                                                    {{ formatCurrency(itemConsumo.valor) }}
                                                </td>
                                            </tr>
                                        </template>
                                    </tbody>
                                </table>
                            </div>

                            <div class="d-flex justify-content-between mt-4">
                                <div>
                                    <div v-if="dados.medico_no_recibo && dados.lista_medicos && dados.lista_medicos.length == 1" class="small">
                                        {{ dados.lista_medicos[0].st_nome_exibicao }}
                                        <div v-if="dados.lista_medicos[0].conselho">
                                            {{ dados.lista_medicos[0].conselho.st_sigla }}
                                            {{ dados.lista_medicos[0].in_numero_conselho }}
                                            <span v-if="dados.lista_medicos[0].estado_conselho">
                                                {{ dados.lista_medicos[0].estado_conselho.st_sigla }}
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <table class="text-right">
                                    <tr class="ml-2">
                                        <td class="font-weight-bold">
                                            Valor Total(R$):
                                        </td>
                                        <td>{{ formatCurrency(total) }}</td>
                                    </tr>
                                    <tr class="ml-2">
                                        <td class="font-weight-bold">
                                            Valor Desconto(R$):
                                        </td>
                                        <td>{{ formatCurrency(desconto) }}</td>
                                    </tr>
                                    <tr class="ml-2">
                                        <td class="font-weight-bold">
                                            Valor Pago(R$):
                                        </td>
                                        <td>
                                            {{
                                                formatCurrency(total - desconto)
                                            }}
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </template>
                    </div>

                    <div v-if="dados" class="mx-auto" style="font-size:14px;">
                        {{
                            dados.unidade_operacao && 
                            dados.unidade_operacao.endereco &&
                            dados.unidade_operacao.endereco.cidade
                                ? dados.unidade_operacao.endereco.cidade.st_cidade + ', '
                                : ""
                        }}
                        <span v-if="dados.dt_data">
                            {{ formatData(dados.dt_data.substr(0,10)) }}
                        </span>
                    </div>

                    <div class="d-flex justify-content-between mt-2 ml-4 mr-4">
                        <div
                            class="d-flex flex-column justify-content-center ml-5 text-center"
                        >
                            <div>
                                __________________________________________
                            </div>
                            <div><small>Paciente</small></div>
                        </div>
                        <div
                            class="d-flex flex-column justify-content-center ml-5 text-center"
                        >
                            <div>
                                __________________________________________
                            </div>
                            <div><small>Clínica</small></div>
                        </div>
                    </div>
                </div>
            </html-report>
            <!-- </div> -->
        </div>

        <!-- Espelho do Atendimento -->
        <template v-if="dados && marcacao">
            <div class="d-flex">
                <div>
                    <laboratorio-etiqueta v-model="dados" />
                </div>
                
                <div>
                    <print-export printid="print-espelho-atendimento" :icon="false">
                        <template v-slot:botao>
                            <span class="mr-2">Espelho do Atendimento</span>
                        </template>
                    </print-export>
                </div>
            </div>

            <div id="print-espelho-atendimento" class="d-none d-print-block">
                <espelho-atendimento :dados="dados" :prazo="dados.exibir_prazo" />
            </div>

        </template>

        <template v-if="marcacao">

            <!-- Outras Marcações -->
            <outras-marcacoes class="mt-3" :dados="marcacao" @reabrir="reabrir" :pode_encaminhar="true" @encaminhar="$emit('encaminhar', $event)" />

            <!-- Documentos para Impressão -->
            <doc-print-atendimento class="mt-3" :marcacao="marcacao" />

        </template>

        <template v-else-if="dados && dados.lista_atendimentos_obj && dados.lista_atendimentos_obj.length">

            <az-sub-title title="Atendimentos" class="mt-3"/>
            <div class="list-group">
                <button type="button" class="list-group-item list-group-item-action d-flex justify-content-between" v-for="(atend, iax) in dados.lista_atendimentos_obj" :key="iax" @click="abrir_atendimento(atend.id_atendimento)">
                    <div>
                        #{{ atend.id_atendimento }}
                    </div>
                    <div>
                        <i class="fa fa-circle text-warning" aria-hidden="true" v-if="atend.conc === false"></i>
                        <i class="fa fa-circle text-success" aria-hidden="true" v-if="atend.conc === true"></i>
                    </div>
                </button>
            </div>
        </template>

    </div>
</template>

<script>
import * as moment from "moment";
import _ from "lodash";
import $ from 'jquery'; 
import HtmlReport from "../../relatorios/HTMLReport.vue";
import OutrasMarcacoes from "../../modulos/recepcao/OutrasMarcacoes.vue";
import PrintExport from "../../shared/PrintExport.vue";
import EspelhoAtendimento from "./EspelhoAtendimento.vue";
import NotaFiscalStatus from "../financeiro/NotaFiscalStatus.vue";
import AzSubTitle from '../../util/AzSubTitle.vue';
import DocPrintAtendimento from '../../modulos/recepcao/DocPrintAtendimento.vue';
import LaboratorioEtiqueta from './LaboratorioEtiqueta.vue';
import SuportPosStatus from "../../shared/SuportPosStatus.vue";
import ZoopPagamento from './ZoopPagamento.vue';

export default {
    data() {
        return {
            dados: null,
            parms: null,
            unidade: null,
            copiasRececibo: [0, 1],
            can_open_zoop: false,
            can_open_suportepos: false,
            block_valor_unit: false,
        };
    },
    props: ["marcacao", "view"],
    components: {
        HtmlReport,
        OutrasMarcacoes,
        PrintExport,
        EspelhoAtendimento,
        NotaFiscalStatus,
        AzSubTitle,
        DocPrintAtendimento,
        LaboratorioEtiqueta,
        SuportPosStatus,
        ZoopPagamento
    },

    methods: {
        concluir () { 
            let lista = this.dados.lista_atendimentos_obj.filter(item => item.conc === false)
                .map(item => item.id_atendimento);

            if ( lista.length ) { 

                this.$util.atualizar(this, { 
                    service: 'atendimentos',
                    func: 'fim_recepcao',
                    dados: {
                        id_atendimento: lista[0],
                        outras: lista.slice(1), 
                    },
                    callback: () => { 
                        $(".modal").modal('hide');
                    }
                });

            }
        },

        precisa_concluir() { 
            if ( this.dados && this.dados.lista_atendimentos_obj && this.dados.lista_atendimentos_obj.length ) {
                return this.dados.lista_atendimentos_obj.find(item => item.conc === false) ? true : false;
            }

            return false;
        },

        abrir_atendimento (id) { 
            $(".modal").modal('hide');
            this.$util.abrir_atendimento(this, id);
        },

        reabrir(item) {
            this.$emit("reabrir", item);
        },

        formatCurrency(n) {
            let formatter = new Intl.NumberFormat("pt-Br", {
                style: "currency",
                currency: "BRL",
                currencyDisplay: "code"
            });

            return formatter.format(n).substr(4);
        },
        formatData(data) {
            return moment(data).format("L");
        },
        imprimirRecibo() {
            this.$refs.reportRecibo.configurarPapel("A5");
            this.$nextTick(() =>
                this.$htmlToPaper("recibo", null, () =>
                    console.log("print recibo")
                )
            );
        },

        abrir(id_pagamento_atendimento) {
            
            id_pagamento_atendimento = 
                id_pagamento_atendimento 
                    ? id_pagamento_atendimento 
                    : ( this.dados ? this.dados.id_pagamento_atendimento : null );
                    
            console.log('abrir', id_pagamento_atendimento);
            
            this.$store.commit("loading", true);

            this.$util
                .loadItem(this, {
                    service: "pagamentos",
                    parms: {
                        id: id_pagamento_atendimento,
                        recibo: true, 
                    },
                    configs: [
                        'recibo-block-valor-unitario', 
                    ]
                })
                .then(res => {
                    this.dados = res;
                    this.can_open_zoop = res.zoop ? true : false;
                    this.can_open_suportepos = res.suportpos ? true : false;

                    if ( res.unidade_operacao ) {
                        if ( res.unidade_operacao.endereco ) {
                            this.unidade.endereco = res.unidade_operacao.endereco;
                        }

                        if ( res.unidade_operacao.st_cnpj ) {
                            this.unidade.st_cnpj = res.unidade_operacao.st_cnpj;
                        }

                        this.unidade.st_unidade_operacao = res.unidade_operacao.st_nome;
                    }

                    let precisa = this.precisa_concluir()

                    this.$emit('precisa_concluir', precisa);

                    if ( this.$store.state.contexto['recibo-block-valor-unitario'] > 0 ) { 
                        this.block_valor_unit = true; 
                    }
                })
                .finally(() => {
                    this.$store.commit("loading", false);
                });

        },

        load(id_marcacao = null) {

            id_marcacao = id_marcacao ? id_marcacao : ( this.marcacao ? this.marcacao.id_marcacao : null );

            let guia_tiss = this.marcacao 
                ? ( this.marcacao.plano && this.marcacao.plano.id_operadora != 1 ) ? true : false
                : false;
            
            if (id_marcacao) {
                this.$store.commit("loading", true);

                this.$util
                    .loadItem(this, {
                        service: "marcacoes",
                        id: id_marcacao,
                        parms: {
                            pagamento: true,
                            guia_tiss: guia_tiss,
                            recibo: true,
                        },
                        with: [
                            "paciente.cadastro.endereco.cidade.estado",
                            "atendimento.atendimento_procedimentos.terceiro.terceiro",
                            "atendimento.pagamentoAtendimento.itemPagamentoAtendimentos.notaFiscalLinks.notaFiscalServico",
                            "atendimento.medico.conselho",
                            "atendimento.medico.estado_conselho",
                            "unidade_operacao:id_unidade_operacao,st_nome,id_endereco,st_cnpj,fl_nota_fiscal,fl_nota_fiscal_eletronica",
                            "unidade_operacao.endereco.cidade.estado",
                            "unidade_operacao.telefoneUnidadeOperacaos.telefone",
                        ]
                    })
                    .then(res => {
                        this.dados = res;
                        this.can_open_zoop = res.zoop ? true : false;

                        if ( res.unidade_operacao ) {
                            if ( res.unidade_operacao.endereco ) {
                                this.unidade.endereco = res.unidade_operacao.endereco;
                            }

                            if ( res.unidade_operacao.st_cnpj ) {
                                this.unidade.st_cnpj = res.unidade_operacao.st_cnpj;
                            }

                            this.unidade.st_unidade_operacao = res.unidade_operacao.st_nome;
                        }
                    })
                    .finally(() => {
                        this.$store.commit("loading", false);
                    });
            }
        },
        gerarNF: function() {
            if (!confirm("Deseja realmente gerar a Nota Fiscal de Serviço?"))
                return;

            this.$util.atualizar(this, {
                service: "nota_fiscal_servico",
                func: "gerar_nf_pagamento_atendimento",
                redir_api: true, 
                toast: true,
                dados: {
                    id_pagamento_atendimento: this.dados.id_pagamento_atendimento
                },
                callback: () => {
                    this.abrir();
                }
            });
        },
        getStatusClass: function(status) {
            switch (status) {
                case "1":
                    return "text-info";
                case "2":
                    return "text-primary";
                case "3":
                    return "text-warning";
                case "4":
                    return "text-success";
                case "5":
                    return "text-danger";

                default:
                    return "text-info";
            }
        }
    },
    computed: {
        texto_rodape: function () {
            if ( this.dados
                && this.dados.cabecalho_laudo
                && this.dados.cabecalho_laudo.st_texto_rodape
                && this.dados.cabecalho_laudo.fl_rodape_recibo ) {
                return this.dados.cabecalho_laudo.st_texto_rodape;
            }

            return null;
        },

        logo_url: function () {
            if ( this.dados
                && this.dados.cabecalho_laudo
                && this.dados.cabecalho_laudo.logo
                && this.dados.cabecalho_laudo.logo.arquivo
                && this.dados.cabecalho_laudo.logo.arquivo.temporary_url ) {
                return this.dados.cabecalho_laudo.logo.arquivo.temporary_url;
            }

            return null;
        },

        nome_empresa: function () {
            if ( this.dados && this.dados.cabecalho_laudo && this.dados.cabecalho_laudo.st_nome_empresa ) {
                return this.dados.cabecalho_laudo.st_nome_empresa;
            }

            return null;
        },

        valor_total: function() {
            return this.metodoPagamentos.reduce((carry, item) => {
                return Number(carry) + Number(item.dc_valor);
            }, 0);
        },
        desconto: function() {
            let total_desconto = 0;
            if (this.dados.desconto != null) {
                total_desconto += Number(this.dados.desconto.dc_valor);
            }
            return total_desconto;
        },
        responsavel: function() {
            let responsavel;
            let doc;

            if ( this.dados.st_responsavel_financeiro ) {
                responsavel = this.dados.st_responsavel_financeiro;

                this.dados.st_cpf_cnpj.lenght == 11
                    ? (doc = "CPF: " + this.$util.formatMask(this.dados.st_cpf_cnpj, "cpf"))
                    : (doc = "CNPJ: " + this.$util.formatMask(this.dados.st_cpf_cnpj, "cnpj"));

                const paciente = this.dados.paciente ? ( this.dados.paciente.st_nome_social ? this.dados.paciente.st_nome_social : this.dados.paciente.st_nome ) : null;

                responsavel += " (" + doc + ( paciente ? ", Paciente: " + paciente : "" ) + ")";

            } else if ( this.dados.fornecedor ) { 

                responsavel = this.dados.fornecedor.search; 

            } else if ( this.dados.paciente ) { 
                responsavel = this.dados.paciente.st_nome_social
                    ? this.dados.paciente.st_nome_social
                    : this.dados.paciente.st_nome +
                        ( 
                            this.dados.paciente.id_cadastro_temporario 
                                ? ''
                                : ( 
                                    " (" +
                                    this.$util.formatMask(
                                        this.dados.paciente.cadastro.st_cpf,
                                        "cpf"
                                    ) +
                                    ") "
                                )
                        );
            }
            console.log('resp', responsavel);
            return responsavel;
        },
        procedimentos: function() {
            return this.dados.procedimentos;

            /*
            let procedimentos = this.dados.procedimentos;
            let pacote = [];
            procedimentos.forEach(item => {
                let tmp = {};
                if (item.procedimento_pacote) {
                    tmp["nome"] =
                        item.procedimento.st_procedimento +
                        " " +
                        item.procedimento_pacote.search;
                    tmp["valor"] = item.procedimento_pacote.pacote.dc_valor;
                    tmp["quantidade"] =
                        item.procedimento_pacote.pacote.id_unidade;
                }
                if (!item.procedimento_pacote) {
                    tmp["nome"] = item.procedimento.st_procedimento;
                    tmp["valor"] =
                        item.in_quantidade * item.dc_valor_procedimento;
                    tmp["quantidade"] = item.in_quantidade;
                }
                tmp["consumos"] = [];
                if (item.atendimento_procedimento_consumos) {
                    let consumos = [];
                    item.atendimento_procedimento_consumos.forEach(consumo => {
                        let consumoItem = {};
                        consumoItem["quantidade"] = consumo.in_quantidade;
                        consumoItem["valor_unitario"] =
                            consumo.dc_valor_unitario;
                        consumoItem["valor"] = consumo.valor_total;
                        consumoItem["nome_item"] = consumo.search;
                        consumos.push(consumoItem);
                    });
                    tmp.consumos = consumos;
                }
                pacote.push(tmp);
            });
            return pacote;
            */
        },
        total: function() {
            // const sum = (acc, item) => acc + Number(item.valor);
            let total_custo = 0;
            this.procedimentos.forEach(item => {
                total_custo += Number(item.valor);
                if (item.consumos != null) {
                    item.consumos.forEach(consumo => {
                        total_custo += consumo.valor;
                    });
                }
            });

            return total_custo;
        },
        // consumos:function(){
        //   let comesebebes= this.dados.atendimento.atendimento_procedimentos;
        //   if()
        //   return comesebebes
        // },
        endereco: function() {
            let endereco = "Endereço: ";
            let isEmpty = true;
            if (this.dados.paciente.cadastro.endereco.st_logradouro) {
                endereco +=
                    this.dados.paciente.cadastro.endereco.st_logradouro + ",";
                isEmpty = false;
            }
            if (this.dados.paciente.cadastro.endereco.st_numero) {
                endereco +=
                    " " +
                    this.dados.paciente.cadastro.endereco.st_numero +
                    " .";
                isEmpty = false;
            }
            if (this.dados.paciente.cadastro.endereco.st_bairro) {
                endereco +=
                    "  Bairro: " +
                    this.dados.paciente.cadastro.endereco.st_bairro +
                    ".";
                isEmpty = false;
            }
            if (
                this.dados.paciente.cadastro.endereco &&
                this.dados.paciente.cadastro.endereco.cidade
            ) {
                endereco +=
                    " " +
                    this.dados.paciente.cadastro.endereco.cidade.st_cidade;
                if (
                    this.dados.paciente.cadastro.endereco.cidade.estado &&
                    this.dados.paciente.cadastro.endereco.cidade.estado.st_sigla
                ) {
                    endereco +=
                        "/" +
                        this.dados.paciente.cadastro.endereco.cidade.estado
                            .st_sigla;
                }

                isEmpty = false;
            }
            return isEmpty ? "" : endereco;
        },
        metodoPagamentos: function() {
            let pagamentos = [];
            let pagamentosArray = this.dados.item_pagamento_atendimentos;

            pagamentosArray
                .filter(
                    item => !item.estorno || item.estorno.ch_situacao != "A"
                )
                .forEach(pagamento => {
                    let st_pagamento = pagamento.forma_pagamento
                        .st_forma_pagamento
                        ? pagamento.forma_pagamento.st_forma_pagamento
                        : "";
                    let forma_pagamento = "";
                    // " R$ " + this.$util.formatMoeda(pagamento.dc_valor);
                    let tmp = {};

                    if (pagamento.forma_pagamento) {
                        if (pagamento.forma_pagamento.bandeira_cartaos) {
                            let cartao = _.find(
                                pagamento.forma_pagamento.bandeira_cartaos,
                                item => {
                                    return (
                                        item.id_bandeira_cartao ==
                                        pagamento.id_bandeira_cartao
                                    );
                                }
                            );

                            forma_pagamento += cartao.st_bandeira_cartao;

                            if (pagamento.st_autorizacao) {
                                forma_pagamento +=
                                    " - Nº Autorização: " +
                                    pagamento.st_autorizacao;
                            }
                            if (pagamento.in_parcelas) {
                                forma_pagamento +=
                                    " - Nº Parcelas: " + pagamento.in_parcelas;
                            }
                        } else if (pagamento.cheque && pagamento.cheque.banco) {
                            forma_pagamento =
                                forma_pagamento + pagamento.cheque.banco.search;
                            forma_pagamento =
                                forma_pagamento +
                                " - Cheque #" +
                                pagamento.cheque.in_numero;
                            forma_pagamento =
                                forma_pagamento +
                                " - Venc.: " +
                                this.$util.getFormatDate(
                                    pagamento.cheque.dt_vencimento
                                );
                        }
                    }
                    tmp["st_pagamento"] = st_pagamento;
                    tmp["forma_pagamento"] = forma_pagamento;
                    tmp["dc_valor"] = pagamento.dc_valor;
                    tmp["transaction_id"] = _.get(pagamento, 'js_outros.zoop.transaction_id');

                    pagamentos.push(tmp);
                });

            return pagamentos;
        },
        possuiNF: function() {
            const nfLinks = this.listaNf;

            return (
                nfLinks != undefined &&
                Array.isArray(nfLinks) &&
                nfLinks.length > 0
            );
        },

        listaNf: function() {
            if ( !this.dados || !this.dados.nota_fiscal_links )
                return [];

            return this.dados.nota_fiscal_links;
        }
    },
    mounted() {
        this.unidade = this.$store.state.unidade;
        this.load();
    }
};
</script>

<style></style>